import { render, staticRenderFns } from "./ListarPedidos.vue?vue&type=template&id=c0524726&scoped=true&"
import script from "./ListarPedidos.vue?vue&type=script&lang=js&"
export * from "./ListarPedidos.vue?vue&type=script&lang=js&"
import style0 from "./ListarPedidos.vue?vue&type=style&index=0&id=c0524726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0524726",
  null
  
)

export default component.exports